import workerUrl from './find-file.worker?worker&url'

export function createFindFileWorker() {
  return new Worker(workerUrl, {type: 'module'})
}
